module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/dash-board/messagecenter/messagecentercontainer/messagecentercontainer.component.css
// module id = ./src/app/dash-board/messagecenter/messagecentercontainer/messagecentercontainer.component.css
// module chunks = main